import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getSelectFitEbsCodes } from "../services/RetailLocationService";

export function useSelectFitEbsCodes(enabled = true, resetKey, callback = () => {}, params) {
    const [selectFitEbsCodes, setSelectFitEbsCodes] = useState([]);

    const {data} = useQuery({
        queryKey: ["selectFitEbsCodes", resetKey, params],
        queryFn: () => getSelectFitEbsCodes(params),
        retry: false,
        enabled: enabled,
    });

    useEffect(() => {
        if (data) {
            setSelectFitEbsCodes(data.selectFitEbsCodes);
            callback(data.selectFitEbsCodes);
        }
    }, [data]);

    return selectFitEbsCodes;
}
